import { render, staticRenderFns } from "./LinkToAppModal.vue?vue&type=template&id=bedbc766&scoped=true&"
import script from "./LinkToAppModal.vue?vue&type=script&lang=js&"
export * from "./LinkToAppModal.vue?vue&type=script&lang=js&"
import style0 from "./LinkToAppModal.vue?vue&type=style&index=0&id=bedbc766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedbc766",
  null
  
)

export default component.exports